import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface HomologyRegionMaxLengthProps {
  homologyRegionMaxLength: number | null;
  updateHomologyRegionMaxLength: (length: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set the maximum length of the homology region in a Gibson assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.homologyRegionMaxLength The maximum length, in base pairs, of the homology region.
 * @param {function} props.updateHomologyRegionMaxLength A function that takes a new length and uses it to update state.
 * @constructor
 */
export function HomologyRegionMaxLength(props: HomologyRegionMaxLengthProps): JSX.Element {
  return (
    <InputWrapper
      id="homologyRegionMaxLength"
      label="Max. length of homology/binding regions (bp)"
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.homologyRegionMaxLength}
        min={0}
        required={true}
        onChange={(e) => {
          props.updateHomologyRegionMaxLength(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
